import { config } from '@cfg';

const gql = String.raw;

class strapiAPI {
  root: this;
  private _url: string;

  constructor(url = config.strapiAPiBaseUrl) {
    this.root = this;
    this._url = url;
  }

  async fetchCharacterLimit() {
    try {
      const response = await fetch(`${this._url}/graphql`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: gql`
            {
              profile {
                Bio {
                  bioCharacterLimit
                }
              }
            }
          `,
        }),
      });
      const json = await response.json();
      return json?.data?.profile?.Bio?.bioCharacterLimit || null;
    } catch (err) {
      console.log('Strapi Error: ', err);
      return err;
    }
  }
}

export default strapiAPI;
